import { AwaitContainer } from '@ibsys/kit';
import { FC, useCallback, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { usePipelines } from '@/entities/jobs';
import { PageContainer } from '@/shared/ui';
import { PipelinesTable } from './PipelinesTable';

const DEFAULT_PAGE_SIZE = 50;

export const PipelinesPage: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  // DataGrid использует 0-based страницы; в URL храним 1-based для читаемости
  const [page, setPage] = useState(() => Math.max(0, +(searchParams.get('page') || 1) - 1));
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);

  const { data, isLoading } = usePipelines({
    limit: pageSize,
    offset: page * pageSize,
  });

  const handlePageChange = useCallback(
    (nextPage: number) => {
      setPage(nextPage);
      setSearchParams((prev) => {
        prev.set('page', (nextPage + 1).toString());
        return prev;
      });
    },
    [setSearchParams],
  );

  const handlePageSizeChange = useCallback(
    (nextSize: number) => {
      setPageSize(nextSize);
      setPage(0);
      setSearchParams((prev) => {
        prev.set('page', '1');
        return prev;
      });
    },
    [setSearchParams],
  );

  return (
    <PageContainer enableScroll={false} className="flex flex-col h-full gap-4 w-full">
      <AwaitContainer isLoading={isLoading} className="flex-1 overflow-hidden">
        <PipelinesTable
          pipelines={data?.items || []}
          total={data?.total ?? 0}
          page={page}
          perPage={pageSize}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
        />
      </AwaitContainer>
    </PageContainer>
  );
};
